export default "__VITE_ASSET__DFiY42Ue__"